/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Contract,
  ContractFactory,
  ContractTransactionResponse,
  Interface,
} from "ethers";
import type {
  Signer,
  AddressLike,
  ContractDeployTransaction,
  ContractRunner,
} from "ethers";
import type { NonPayableOverrides } from "../../common";
import type {
  XypeResolver,
  XypeResolverInterface,
} from "../../contracts/XypeResolver";

const _abi = [
  {
    inputs: [
      {
        internalType: "contract Registry",
        name: "_registry",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "AccessControlBadConfirmation",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "bytes32",
        name: "neededRole",
        type: "bytes32",
      },
    ],
    name: "AccessControlUnauthorizedAccount",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "caller",
        type: "address",
      },
    ],
    name: "ResolverNotAuthorized",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "address",
        name: "a",
        type: "address",
      },
    ],
    name: "AddrChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "string",
        name: "name",
        type: "string",
      },
    ],
    name: "NameChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "registrar",
        type: "address",
      },
    ],
    name: "ResolverAddRegistrar",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "previousAdminRole",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "newAdminRole",
        type: "bytes32",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "OPERATOR_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "REGISTRAR_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "registrar",
        type: "address",
      },
    ],
    name: "addRegistrar",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
    ],
    name: "addr",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32[]",
        name: "nodes",
        type: "bytes32[]",
      },
      {
        internalType: "address[]",
        name: "a",
        type: "address[]",
      },
    ],
    name: "batchSetAddr",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
    ],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "registry",
    outputs: [
      {
        internalType: "contract Registry",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "callerConfirmation",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "a",
        type: "address",
      },
    ],
    name: "setAddr",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        internalType: "string",
        name: "newName",
        type: "string",
      },
    ],
    name: "setName",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceID",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type XypeResolverConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: XypeResolverConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class XypeResolver__factory extends ContractFactory {
  constructor(...args: XypeResolverConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override getDeployTransaction(
    _registry: AddressLike,
    operator: AddressLike,
    overrides?: NonPayableOverrides & { from?: string }
  ): Promise<ContractDeployTransaction> {
    return super.getDeployTransaction(_registry, operator, overrides || {});
  }
  override deploy(
    _registry: AddressLike,
    operator: AddressLike,
    overrides?: NonPayableOverrides & { from?: string }
  ) {
    return super.deploy(_registry, operator, overrides || {}) as Promise<
      XypeResolver & {
        deploymentTransaction(): ContractTransactionResponse;
      }
    >;
  }
  override connect(runner: ContractRunner | null): XypeResolver__factory {
    return super.connect(runner) as XypeResolver__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): XypeResolverInterface {
    return new Interface(_abi) as XypeResolverInterface;
  }
  static connect(
    address: string,
    runner?: ContractRunner | null
  ): XypeResolver {
    return new Contract(address, _abi, runner) as unknown as XypeResolver;
  }
}
